module.exports = __webpack_public_path__ + "img/sh.4f57b817.png";